import { useEffect, useState } from 'react'
import { LinkField } from '@prismicio/client'

export const useWindowSize = () => {
  const isSSR = typeof window === 'undefined'
  const [windowSize, setWindowSize] = useState({
    width: isSSR ? 1200 : window.innerWidth,
    height: isSSR ? 800 : window.innerHeight,
  })

  const changeWindowSize = () => {
    setWindowSize({ width: window.innerWidth, height: window.innerHeight })
  }

  useEffect(() => {
    window.addEventListener('resize', changeWindowSize)

    return () => {
      window.removeEventListener('resize', changeWindowSize)
    }
  }, [])

  return windowSize
}

export const getWindowLocationParam = (param: string): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }
  return new URL(window.location.href).searchParams.get(param)
}

export const decorateURLWithUTMAndTIDParams = (
  link: LinkField,
  tid: string | undefined
): LinkField => {
  const isSSR = typeof window === 'undefined'

  if (isSSR || !('url' in link)) {
    return link
  }

  const url = new URL(link.url)

  const queryParams = [
    'utm_medium',
    'utm_source',
    'utm_campaign',
    'utm_content',
    'utm_term',
  ]

  for (const param of queryParams) {
    const queryParamValue = getWindowLocationParam(param)
    if (queryParamValue) {
      url.searchParams.set(param, queryParamValue)
    }
  }

  if (tid) {
    url.searchParams.set('tid', tid)
  }

  return { ...link, url: url.toString() }
}
